export interface ProductVariant {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  stock: number;
}

export interface Product {
  id: string;
  name: string;
  slug: string;
  description: string;
  category: string;
  subCategory?: string;
  price: number;
  originalPrice?: number;
  rating: number;
  reviewsCount: number;
  imageUrl: string;
  images?: string[];
  isInStock: boolean;
  bestseller?: boolean;
  variants?: ProductVariant[];
  features?: string[];
}

export const CATEGORIES = [
  "Pooja Essentials",
  "Aquarium & Pets",
  "Ayurvedic & Wellness",
  "Decorative Flowery"
];

export const products: Product[] = [
  {
    id: "p1",
    name: "Premium 5 Mukhi Rudraksha Mala",
    slug: "premium-5-mukhi-rudraksha-mala",
    description: "Authentic 5 Mukhi Rudraksha sourced directly from Nepal. Known for its spiritual healing properties.",
    category: "Pooja Essentials",
    subCategory: "Rudraksha",
    price: 499,
    originalPrice: 899,
    rating: 4.8,
    reviewsCount: 1245,
    imageUrl: "https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?auto=format&fit=crop&q=80&w=600",
      "https://images.unsplash.com/photo-1515091943-9d5c0ad475af?auto=format&fit=crop&q=80&w=600",
      "https://images.unsplash.com/photo-1596758414418-bd2789178ad8?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
    bestseller: true,
    features: ["108+1 Beads", "Lab Certified", "Silver Plated Caps"]
  },
  {
    id: "p2",
    name: "Pure Bhimseni Camphor (Karpur)",
    slug: "pure-bhimseni-camphor",
    description: "100% pure deseeded bhimseni kapoor for daily pooja use. No ash left behind.",
    category: "Pooja Essentials",
    subCategory: "Karpur",
    price: 199,
    rating: 4.9,
    reviewsCount: 341,
    imageUrl: "https://images.unsplash.com/photo-1614736340366-eb1f4a46011c?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1614736340366-eb1f4a46011c?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
    variants: [
      { id: "v1", name: "50 gm", price: 199, originalPrice: 250, stock: 100 },
      { id: "v2", name: "100 gm", price: 349, originalPrice: 500, stock: 50 },
      { id: "v3", name: "250 gm", price: 799, originalPrice: 1000, stock: 20 },
      { id: "v4", name: "500 gm", price: 1499, originalPrice: 2000, stock: 10 },
    ]
  },
  {
    id: "p3",
    name: "Designer Poshaak for Laddoo Gopal",
    slug: "designer-poshaak-laddoo-gopal",
    description: "Hand-stitched velvet resham dress for Krishnaji, perfect for Janmashtami and daily darshan.",
    category: "Pooja Essentials",
    subCategory: "Deity Clothes",
    price: 599,
    originalPrice: 999,
    rating: 4.6,
    reviewsCount: 89,
    imageUrl: "https://images.unsplash.com/photo-1594911772125-07fc7a2d8d9f?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1594911772125-07fc7a2d8d9f?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
  },
  {
    id: "a1",
    name: "Complete Aquarium Starter Kit (20 Gallon)",
    slug: "aquarium-starter-kit-20-gallon",
    description: "Everything you need to start your first aquarium: tank, LED light, filter, and water conditioner.",
    category: "Aquarium & Pets",
    price: 3499,
    originalPrice: 4500,
    rating: 4.5,
    reviewsCount: 200,
    imageUrl: "https://images.unsplash.com/photo-1522069169874-c58ec4b76be5?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1522069169874-c58ec4b76be5?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
    bestseller: true,
  },
  {
    id: "a2",
    name: "Premium Goldfish Flakes",
    slug: "premium-goldfish-flakes",
    description: "High-protein flakes formulated for all varieties of soft and hard water fish.",
    category: "Aquarium & Pets",
    price: 249,
    rating: 4.7,
    reviewsCount: 56,
    imageUrl: "https://images.unsplash.com/photo-1535591273668-578e31182c4f?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1535591273668-578e31182c4f?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
  },
  {
    id: "o1",
    name: "Ayurvedic Joint Relief Oil",
    slug: "ayurvedic-joint-relief-oil",
    description: "Traditional formulation with Ashwagandha and Mahanarayan meant to relieve joint and muscle pain.",
    category: "Ayurvedic & Wellness",
    price: 399,
    originalPrice: 600,
    rating: 4.5,
    reviewsCount: 93,
    imageUrl: "https://images.unsplash.com/photo-1608248593842-8d760777eaf3?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1608248593842-8d760777eaf3?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
    bestseller: true,
  },
  {
    id: "o2",
    name: "Deep Sleep Lavender Massage Oil",
    slug: "deep-sleep-lavender-massage-oil",
    description: "Relaxing body oil infused with pure lavender extracts to help reduce anxiety and promote sleep.",
    category: "Ayurvedic & Wellness",
    price: 549,
    rating: 4.9,
    reviewsCount: 618,
    imageUrl: "https://images.unsplash.com/photo-1615397323171-ecf3cd9bc594?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1615397323171-ecf3cd9bc594?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
  },
  {
    id: "d1",
    name: "Paraffin Wax Coated Floating Lotus",
    slug: "paraffin-wax-coated-floating-lotus",
    description: "Beautifully hand-crafted wax lotuses that float on water. Ideal for festive decor and Diwali centerpieces.",
    category: "Decorative Flowery",
    price: 299,
    originalPrice: 400,
    rating: 4.4,
    reviewsCount: 34,
    imageUrl: "https://images.unsplash.com/photo-1655823791102-1d57579f64db?auto=format&fit=crop&q=80&w=400",
    images: [
      "https://images.unsplash.com/photo-1655823791102-1d57579f64db?auto=format&fit=crop&q=80&w=600"
    ],
    isInStock: true,
  }
];
